module.exports = __webpack_public_path__ + "static/media/logo-barreiraspiaui.63e1906c.png";